import { isEmpty } from "../../data/validation";


export function processFilter(definition, filter) {
	if (!definition) {
		return;
	}
	if (definition.getProcessForSearch) {
		const processForSearch = definition.getProcessForSearch();
		if (processForSearch) {
			const name = definition.getName();
			filter[name] = processForSearch(filter[name]);
		}
	}
	if (definition.getItems) {
		definition.getItems().forEach(item => {
			processFilter(item, filter);
		});
	}
}


export function processObjectParameters(filter) {
	if (!filter) {
		return null;
	}
	for (const key in filter) {
		const value = filter[key];
		if (value && typeof value === 'object') {
			if (!isEmpty(value.from)) {
				filter[key + 'From'] = value.from;
			}
			if (!isEmpty(value.to)) {
				filter[key + 'To'] = value.to;
			}
		}
	}
	return filter;
}

let valueProcessorMap = {
};

export function registerValueProcessor(name, func) {
	valueProcessorMap[name] = func;
}

export function processAdvancedFilter(node) {
	if (!node) {
		return null;
	}
	if (node.formItem) {
		const processValue = node.formItem.processValue;
		if (typeof processValue === 'function') {
			node.value = processValue(node.value);
		} else if (typeof processValue === 'string') {
			const func = valueProcessorMap[processValue];
			if (func) {
				node.value = func(node.value);
			}
		}
	}
	if (node.nodes) {
		node.nodes.forEach(node => {
			processAdvancedFilter(node);
		});
	}
	return node;
}
